module.exports = __webpack_public_path__ + "static/media/one.592798b9.png";